export default {
  data() {
    return {
      channels: [
        {
          id: 1,
          icon: 'fas fa-envelope',
          text: 'Email',
          name: 'email',
        },
        {
          id: 2,
          icon: 'fas fa-sms',
          text: 'Sms',
          name: 'sms',
        },
        {
          id: 3,
          icon: 'fas fa-phone fa-rotate-90',
          text: 'Ivr',
          name: 'ivr',
        },
        {
          id: 4,
          icon: 'fas fa-robot',
          text: 'Bot',
          name: 'bot',
        },
        {
          id: 5,
          icon: 'fas fa-user',
          text: 'Humano',
          name: 'human',
        },
        {
          id: 6,
          icon: 'fas fa-user',
          text: 'Humano (manual)',
          name: 'manual_human',
        },
        {
          id: 7,
          icon: 'fab fa-whatsapp',
          text: 'Whatsapp',
          name: 'whatsapp',
        },
        {
          id: 8,
          icon: 'fas fa-envelope',
          text: 'Email',
          name: 'in_correo',
        },
        {
          id: 9,
          icon: 'fas fa-comments',
          text: 'Sms',
          name: 'in_sms',
        },
        {
          id: 10,
          icon: 'fas fa-home',
          text: 'Visita',
          name: 'visit',
        },
      ],
    };
  },
  computed: {
    channelNames() {
      return this.channels.map(item => item.id);
    },
    managementChannels() {
      return this.channels.filter(item => ['human', 'bot', 'email', 'sms', 'ivr'].includes(item.name));
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/channelsV2.js